import { render, staticRenderFns } from "./XvOrdersHistory.vue?vue&type=template&id=27eabb7d&"
import script from "./XvOrdersHistory.vue?vue&type=script&lang=ts&"
export * from "./XvOrdersHistory.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports